<script lang="ts">
  import { extraObjectsConfig } from "../config/extraObjects";
  import ExtraObject from "./ExtraObject.svelte";
  import { assetsProgress } from "../store/AppState";

  export let onLoad: () => void;

  $: loadedCounter = 0;

  const handleExtraObjectLoad = () => {
    loadedCounter++;
    $assetsProgress += 1;
    if (loadedCounter === extraObjectsConfig.length) {
      onLoad();
    }
  };
</script>

<div class="extra-objects-container">
  {#each extraObjectsConfig as object}
    <ExtraObject config={object} onLoad={() => handleExtraObjectLoad()} />
  {/each}
</div>

<style>
</style>
